module.exports = __webpack_public_path__ + "img/question.9c5847e0.png";